export const MOCK_VIDEO_LIST = {
  code: 0,
  message: "success",
  data: {
    total: 25,
    list: Array.from({ length: 10 }).map((_, index) => ({
      id: index + 1,
      material_id: `178${Math.floor(Math.random() * 1000000000)}`,
      filename: `Mock_Video_${index + 1}.mp4`,
      origin_filename: `Original_Video_${index + 1}.mp4`,
      ad_id: `178${Math.floor(Math.random() * 1000000000)}`,
      ad_name: `Mock Advertiser ${index + 1}`,
      create_time: "2023-10-27 10:00:00",
      task_status: [1, 2, 3, 5][Math.floor(Math.random() * 4)], // Random status
      audit_msg: "审核通过",
      video_url: "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4"
    }))
  }
};

export const MOCK_PRIMARY_ACCOUNTS = {
  code: 0,
  message: "success",
  data: {
    total: 5,
    list: Array.from({ length: 5 }).map((_, index) => ({
      advertiser_id: `178${Math.floor(Math.random() * 1000000000)}`,
      advertiser_name: `Mock Primary Account ${index + 1}`,
      status: 1
    }))
  }
};

export const MOCK_SUCCESS = {
  code: 0,
  message: "操作成功",
  data: {}
};

export const MOCK_APP_INFO = {
  code: 0,
  message: "success",
  data: {
    list: [
      {
        app_id: "mock_app_id_12345",
        name: "Mock Application"
      }
    ]
  }
};

export const MOCK_VIDEO_URL = {
    code: 0,
    message: "success",
    data: {
        url: "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4"
    }
}
